// Runtime configuration loader
// This module provides configuration that can be set at runtime (container start)
// instead of being baked in at build time, enabling image replication across environments.
//
// How it works:
// 1. At container startup, entrypoint.sh generates /usr/share/nginx/html/config.js
// 2. config.js sets window.RUNTIME_CONFIG with environment-specific values
// 3. This module reads from window.RUNTIME_CONFIG, falling back to process.env for local dev

const getRuntimeConfig = () => {
  // Check if runtime config was injected (production/deployed environments)
  if (typeof window !== 'undefined' && window.RUNTIME_CONFIG) {
    return window.RUNTIME_CONFIG;
  }
  
  // Fallback to process.env for local development (npm start)
  return {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    REACT_APP_ACCOUNT_SERVICE_URL: process.env.REACT_APP_ACCOUNT_SERVICE_URL,
    REACT_APP_STAFF_EVAL_LAMBDA_URL: process.env.REACT_APP_STAFF_EVAL_LAMBDA_URL,
    REACT_APP_DEFAULT_CLIENT_ID: process.env.REACT_APP_DEFAULT_CLIENT_ID,
    REACT_APP_GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID,
  };
};

const config = getRuntimeConfig();

// Export individual config values with sensible defaults
export const API_BASE_URL = config.REACT_APP_API_BASE_URL || 'http://localhost:3001';
export const ACCOUNT_SERVICE_URL = config.REACT_APP_ACCOUNT_SERVICE_URL || 'http://localhost:8000';
export const STAFF_EVAL_LAMBDA_URL = config.REACT_APP_STAFF_EVAL_LAMBDA_URL || 'https://u6uyjnk4flyfefaqsl7p6yoz5a0gcdsj.lambda-url.us-east-1.on.aws/';
export const DEFAULT_CLIENT_ID = config.REACT_APP_DEFAULT_CLIENT_ID || 'Pallium';
export const GA_MEASUREMENT_ID = config.REACT_APP_GA_MEASUREMENT_ID || '';

// Export the full config object for debugging
export const getConfig = () => ({
  API_BASE_URL,
  ACCOUNT_SERVICE_URL,
  STAFF_EVAL_LAMBDA_URL,
  DEFAULT_CLIENT_ID,
  GA_MEASUREMENT_ID,
  source: typeof window !== 'undefined' && window.RUNTIME_CONFIG ? 'runtime' : 'build-time',
});

export default config;

